import React from 'react';

const FamilyTreeNode = ({ member, relationshipType }) => {
  return (
    <div className="relative">
      <div
        className="bg-[#fffbf0] p-4 rounded-xl border-2 border-[#8b4513] relative group transition-all duration-300 hover:shadow-xl"
        style={{ boxShadow: '4px 4px 0px rgba(139, 69, 19, 0.2)' }}
      >
        <div className="text-center">
          <h3 className="font-bold text-[#8b4513]">{member.name}</h3>
          {member.title && <p className="text-sm text-[#8b4513]/70">{member.title}</p>}
          {member.years && <p className="text-xs text-[#8b4513]/60">{member.years}</p>}
          <p className="text-xs text-[#8b4513]/80 mt-1">{relationshipType}</p>
        </div>

        {member.description && (
          <div className="absolute z-10 invisible group-hover:visible bg-white p-3 rounded-lg shadow-lg border border-[#8b4513]/20 w-64 text-sm text-[#5c2e0a] top-full left-1/2 transform -translate-x-1/2 mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            {member.description}
          </div>
        )}
      </div>
    </div>
  );
};

export default FamilyTreeNode;
